import { Container, Dropdown, Form, Navbar } from "react-bootstrap";
import style from "./styles.module.css";
import { useDispatch, useSelector } from "react-redux";
import { IReduxState } from "../../utils/types";
import { LogoutAction } from "../../Redux/Actions/AuthAction";
import { ReactComponent as UserIcon } from '../../Assets/Icons/person-circle.svg'
//import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";

const Header = (props: any) => {
  const dispatch = useDispatch();
  const reduxState = useSelector((state: IReduxState) => state.Auth);
  const is_login = reduxState?.user && Object.keys(reduxState?.user).length === 0
  //const { loginWithRedirect } = useAuth0();
  const navigateTo = useNavigate();

  const handleLogin = async () => {
    // await loginWithRedirect({
    //   prompt: "login",
    //   appState: {
    //     returnTo: "/redirect",
    //   },
    // });
    navigateTo('/login')
  };

  // handles logout button
  const handleLogout = async () => {
    await dispatch(LogoutAction());
  };

  return (
    <div className={style.top_header}>
      <Navbar style={{ padding: '0' }} >
        <Container fluid>
          <Navbar.Toggle />
          <Navbar.Collapse>
            <Form className={style.user_dropdown}>
              <Dropdown className={style.dropdown_menu_main}>
                <Dropdown.Toggle
                  className={style.dropdown_name}
                  variant="light"
                  id="dropdown-basic"
                >
                  {/* <UserIcon /> */}
                  <div className={style.user_profile}>
                    <div className={style.profile_icon}>
                      <span className={style.profile_name}>
                        {!is_login && reduxState?.user?.given_name && reduxState?.user?.family_name && reduxState?.user?.given_name?.charAt(0) +
                          reduxState?.user?.family_name?.charAt(0)}
                        {is_login && <UserIcon />}
                      </span>
                      <div className={style.user_status}>
                        <span className={style.user_status_online}></span>
                      </div>
                    </div>
                  </div>
                </Dropdown.Toggle>

                <Dropdown.Menu className={style.dropdown_menu}>
                  {is_login && <Dropdown.Item onClick={handleLogin}>Log In</Dropdown.Item>}
                  {!is_login && <Dropdown.Item onClick={handleLogout}>Log out</Dropdown.Item>}
                </Dropdown.Menu>
              </Dropdown>
            </Form>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </div>
  );
};

export default Header;
